var __jsx = React.createElement;
import { Transition } from '@headlessui/react';
import APP_CONFIGURATION from '@lib/app.config';
import { useCustomer } from '@lib/context/shared/customer-context';
import { useIsLoadingResources } from '@lib/context/shared/loading-resources-context';
import LoadingAnimation from '@modules/shared/animations/loading';
import React, { Fragment } from 'react';
const MuscleLoadingScreen = () => {
  const {
    isLoadingPage
  } = useIsLoadingResources();
  const {
    isLoadingCustomer
  } = useCustomer();
  return __jsx(Transition.Root, {
    show: isLoadingPage || isLoadingCustomer,
    as: Fragment
  }, __jsx(Transition.Child, {
    as: Fragment,
    enter: "ease-out duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, __jsx("div", {
    className: "fixed inset-0 bg-white bg-opacity-90 transition-opacity z-[100000] flex justify-center items-center"
  }, __jsx(LoadingAnimation, {
    height: APP_CONFIGURATION.config.resourcesAnimationHeight,
    color: APP_CONFIGURATION.colors.globals.loading_animation,
    loadingApp: false,
    canForceEntityLoader: APP_CONFIGURATION.config.useSearhAnimationInResources || APP_CONFIGURATION.config.addEntityLogoInLoadingAnimation
  }))));
};
export default MuscleLoadingScreen;